import { ReaderStatCardItem } from './ReaderStatCard'
import { useStats } from '../../../lib/ctx/stats'
import pluralize from 'pluralize'

export const useStatCards = () => {
  const stats = useStats((s) => s.stats)
  const booksRead = stats?.mom_books_read?.total_count || 0
  const bestStreak = stats?.streaks?.best_streak?.count || 0
  const avgRating = stats?.ratings?.average || 0

  const statsList: ReaderStatCardItem[] = [
    {
      hide: false,
      title: 'Books read',
      value: booksRead.toString(),
      unit: pluralize('book', booksRead),
      icon: 'trophy',
    },
    {
      hide: false,
      title: 'Best streak',
      value: bestStreak.toString(),
      unit: pluralize('day', bestStreak),
      icon: 'flashlight',
    },
    {
      hide: false,
      title: 'Average rating',
      value: `${avgRating === 0 ? 'N/A' : avgRating}`,
      unit: pluralize('star', avgRating),
      icon: 'user-heart',
    },
  ]

  return statsList
}
